import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import flexbox from 'styles/utils/flexbox';

function TabMailComponent({ language, airlineWhitelabel }) {
  let _href = `https://help.tripx.se/hc/${language}/requests/new`;

  if (airlineWhitelabel) {
    _href = _href + `?brand=${airlineWhitelabel.brand}`;
  }

  return (
    <Root>
      <Message>
        <FormattedMessage
          id={'customerService.mail.paragraph'}
          description={
            'If you still have a question, we recommend that you send us an email through our online form. We usually respond within 24 hours.'
          }
          defaultMessage={
            'If you still have a question, we recommend that you send us an email through our online form. We usually respond within 24 hours.'
          }
        />
      </Message>
      <a href={_href} target='_blank' rel='noopener noreferrer'>
        <SendEmailButton>
          <FormattedMessage
            id={'sendEmail.button.label'}
            description={'Send us an email'}
            defaultMessage={'Send us an email'}
          />
        </SendEmailButton>
      </a>
    </Root>
  );
}

export default TabMailComponent;

const Root = styled.div`
  ${flexbox({
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  })}
`;

const Message = styled.div`
  margin-bottom: 10px;
  max-width: 422px;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.text.templates.header};
  line-height: 1.54;
`;

const SendEmailButton = styled.button`
  height: 48px;
  padding: 10px 15px;
  background-color: ${({ theme }) => theme.colors.adjacent.default};
  border: none;
  border-radius: 4px;
  font-size: 20px;
  font-weight: bold;
  color: ${({ theme }) => theme.colors.text.white};
  cursor: pointer;
`;
